<template>
  <div class="login">
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="px-8 py-4">
            <h3 class="title">Inicia sesión</h3>
            <form ref="form">
              <v-text-field
                v-model="email"
                :error-messages="emailErrors"
                label="Correo electrónico"
                id="emailtext"
                required
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="password"
                :error-messages="passwordErrors"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                id="password"
                name="password"
                label="Contraseña"
                required
                @click:append="showPassword = !showPassword"
                @input="$v.password.$touch()"
                @blur="$v.password.$touch()"
                v-on:keyup.enter="enterPressed"
              ></v-text-field>

              <p v-if="error" class="error-2">
                Has introducido mal el correo electrónico o la contraseña.
              </p>

              <p>&nbsp;</p>

              <v-btn class="mr-4" @click="submit"> Acceder </v-btn>
              <v-btn @click="clear"> Limpiar </v-btn>

              <p>&nbsp;</p>
            </form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// :rules="[rules.required, rules.min]"
import { validationMixin } from "vuelidate";
import { required, email, minLength } from "vuelidate/lib/validators";

import { mapMutations, mapState } from "vuex";
import auth from "../auth";

export default {
  mixins: [validationMixin],

  validations: {
    email: { required, email },
    password: { required, minLength: minLength(6) },
  },

  data: () => ({
    email: "",
    password: "",
    error: false,
    showPassword: false,
  }),
  computed: {
    ...mapState(["isLogged", "loggedUser"]),
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email &&
        errors.push(
          "Debe ser tener el formato correcto de una dirección de correo electrónico."
        );
      !this.$v.email.required &&
        errors.push("El correo electrónico es obligatorio.");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required &&
        errors.push("La contraseña es obligatoria.");
      !this.$v.password.minLength &&
        errors.push("La contraseña debe tener al menos 6 caracteres.");
      return errors;
    },
  },
  methods: {
    ...mapMutations(["updateLogged", "hideAlert"]),
    enterPressed() {
      this.submit();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$anyError) this.login();
    },
    clear() {
      this.$v.$reset();
      this.email = "";
      this.password = "";
    },
    async register() {
      try {
        const response = await auth.register(this.email, this.password);
        this.$router.push("/");
      } catch (error) {
        console.log(error);
      }
    },
    async login() {
      try {
        const response = await auth.login(this.email, this.password);
        if (response.data.status == 200) {
          this.hideAlert();
          const user = {
            name: response.data.name,
            email: this.email,
            token: response.data.token,
            level: response.data.level,
            avatar: response.data.avatar,
          };
          auth.setUserLogged(user);
          this.updateLogged(user);
          this.$router.push("/");
        } else {
          this.error = true;
          this.password = "";
          password.focus();
        }
      } catch (error) {
        console.log(error);
        this.error = true;
        this.password = "";
      }
    },
  },
  mounted() {
    emailtext.focus();
  },
};
</script>

<style scoped>
.login {
  padding: 2rem;
}
.title {
  text-align: center;
}
.form {
  margin: 3rem auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 20%;
  min-width: 350px;
  max-width: 100%;
  background: rgba(19, 35, 47, 0.9);
  border-radius: 5px;
  padding: 40px;
  box-shadow: 0 4px 10px 4px rgba(0, 0, 0, 0.3);
}
.form-label {
  margin-top: 2rem;
  color: white;
  margin-bottom: 0.5rem;
}
.form-label:first-of-type {
  margin-top: 0rem;
}
.form-input {
  padding: 10px 15px;
  background: none;
  background-image: none;
  border: 1px solid white;
  color: white;
}
.form-input:focus {
  outline: 0;
  border-color: #1ab188;
}
.form-submit {
  background: #1ab188;
  border: none;
  color: white;
  margin-top: 3rem;
  padding: 1rem 0;
  cursor: pointer;
  transition: background 0.2s;
}
.form-submit:hover {
  background: #0b9185;
}
.error {
  margin: 1rem 0 0;
  color: #ffffff;
  background: red;
  padding: 0.5em 0em;
}
.error-2 {
  margin: 1rem 0 0;
  color: #ff5252;
  background: white;
  padding: 0.5em 0em;
}
.container {
  max-width: 500px;
}
</style>